import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import _find from 'lodash/find';

export default create()(
  immer((set) => ({
    dashboardTitle: 'New Dashboard',
    isDashboardEditable: false,
    justSaved: false,
    widgets: [],
    rowCount: localStorage.getItem('dashboard-rowCount')
      ? Number(localStorage.getItem('dashboard-rowCount'))
      : 10,
    changeJustSaved: (justSaved) =>
      set((state) => {
        state.justSaved = justSaved;
      }),
    changeIsDashboardEditable: (isDashboardEditable) =>
      set((state) => {
        state.isDashboardEditable = isDashboardEditable;
      }),
    renameDashboardTitle: (title) =>
      set((state) => {
        state.dashboardTitle = title;
      }),
    addTemplateAsWidget: (template) =>
      set((state) => {
        const defaultWidgetConfig = {
          ...template,
          position: {
            i: template._id,
            x: 0,
            y: state.widgets.length,
            h: 1,
            w: 14,
            minW: 4,
            minH: 1,
          },
          outputData: [],
          loading: true,
          errorMessage: '',
          alreadyExisting: false,
        };
        state.widgets.push(defaultWidgetConfig);
      }),
    updateDashboardLayouts: (layouts) =>
      set((state) => {
        state.widgets = state.widgets.map((widget) => {
          const updatedPosition = _find(layouts, { i: widget.position.i });
          if (updatedPosition) {
            widget.position = updatedPosition;
          }
          return widget;
        });
      }),
    updateWidgetLoading: (_id, loading) =>
      set((state) => {
        state.widgets = state.widgets.map((widget) => {
          if (widget._id === _id) {
            widget.loading = loading;
          }
          return widget;
        });
      }),
    updateWidgetData: (id, data) =>
      set((state) => {
        state.widgets = state.widgets.map((widget) => {
          if (widget.position.i === id) {
            widget.outputData = data;
          }
          return widget;
        });
      }),
    updateWidgetMeta: (id, data) =>
      set((state) => {
        state.widgets = state.widgets.map((widget) => {
          if (widget.position.i === id) {
            widget['conversationId'] = data.conversationId;
            widget['messageId'] = data.messageId;
            widget['stepId'] = data.stepId;
          }
          return widget;
        });
      }),
    setWidgetErrorMessage: (id, message) =>
      set((state) => {
        let index = state.widgets.findIndex((widget) => widget._id === id);
        if (index >= 0) {
          state.widgets[index].errorMessage = message;
        }
      }),
    updateWidgetTitle: (id, data) =>
      set((state) => {
        let index = state.widgets.findIndex((widget) => widget._id === id);
        if (index >= 0) {
          state.widgets[index].name = data;
        }
      }),
    updateWidgetDescription: (id, data) =>
      set((state) => {
        state.widgets = state.widgets.map((widget) => {
          if (widget.position.i === id) {
            widget.description = data;
          }
          return widget;
        });
      }),
    removeWidget: (widgetId) =>
      set((state) => {
        state.widgets = state.widgets.filter(
          (widget) => widget._id !== widgetId
        );
      }),
    addDefaultWidgets: (widgets) => {
      set((state) => {
        widgets.map((widget) => {
          const defaultWidget = {
            position: {
              i: widget.id,
              x: widget.position.x,
              y: widget.position.y,
              h: widget.position.h,
              w: widget.position.w,
              minW: 4,
              minH: 1,
            },
            _id: widget.id,
            name: widget.name,
            description: widget.description,
            outputData: [],
            outputTypes: widget.outputTypes,
            errorMessage: '',
            alreadyExisting: true,
            chartType: widget?.chartType,
          };
          state.widgets.push(defaultWidget);
        });
      });
    },
    changeRowCount: (newCount) =>
      set((state) => {
        state.rowCount = newCount;
      }),
    resetWidgets: (widgets) =>
      set((state) => {
        state.widgets = widgets;
      }),
    resetToDefaults: () => {
      set((state) => {
        state.widgets = [];
        state.dashboardTitle = 'New Dashboard';
        state.isDashboardEditable = false;
        state.justSaved = false;
      });
    },
  }))
);
